export default "__VITE_ASSET__bdee310d__"